import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      grid-column-start: 1;\n      grid-row-start: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      grid-column-start: 2;\n      grid-row-start: 1;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        padding-top: 4rem;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    ",
        " {\n      ",
        "\n      ",
        "\n      ",
        "\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var ModuleContainerWrapper = /*#__PURE__*/ styled("div", {
    target: "e1iauwtx0"
})(function(param) {
    var isFirstColumn = param.isFirstColumn;
    return isFirstColumn && css(_templateObject());
}, " ", function(param) {
    var isSecondColumn = param.isSecondColumn;
    return isSecondColumn && css(_templateObject1());
}, " ", function(param) {
    var isLargeAtLG = param.isLargeAtLG, theme = param.theme;
    return isLargeAtLG && css(_templateObject2(), theme.mq("lg"));
}, " ", function(param) {
    var theme = param.theme, isNoneAtXL = param.isNoneAtXL, isSmallAtXL = param.isSmallAtXL, isLargeAtXL = param.isLargeAtXL;
    return css(_templateObject3(), theme.mq("xl"), isNoneAtXL && "padding-top: 0rem;", isSmallAtXL && "padding-top: 0.5rem;", isLargeAtXL && "padding-top: 4rem;");
});
export { ModuleContainerWrapper };
